import Actions from "../../model/constant/actions"
import ReducerUtils from "../../utils/ReducerUtils"

const FetchingBiddingStrategies = ReducerUtils.createReducer<boolean>(false,{
  [Actions.RETRIEVING_BIDDING_STRATEGIES] : ()=>true,
  [Actions.RETRIEVE_BIDDING_STRATEGIES]   : ()=>false
})

export default FetchingBiddingStrategies
